import { useState } from "react";
import axios from "../../../lib/axios";

function useResetPassword() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const request = async (token, password, passConfirm) => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await axios.post("api/account/reset-pw", {
        token,
        password,
        password_confirmation: passConfirm,
      });

      console.log(response);
      const data = response.data;
      setSuccess(data.message);
    } catch (error) {
      console.log(error.response);
      const status = error.response.status;
      if (status >= 400 && status <= 500) {
        setError(error.response.data.message);
        return;
      }
      return error.response.data.errors;
    } finally {
      setLoading(false);
    }
  };

  return [request, loading, error, success];
}

export default useResetPassword;
